export default __webpack_public_path__ + "static/media/anomaly-hs-code-icon.7352294e.svg";